module.exports = __webpack_public_path__ + "img/schema_verticalisateur_1a.2b18f4b6.svg";